import { ROUTES } from '@routes/routes.constants';

export const clubHouseRoutes = [
  {
    path: ROUTES.CLUB_HOUSE_RESERVATION,
    lazy: async () => ({
      Component: (
        await import('@views/ClubHouseReservationPage/ClubHouseReservationPage')
      ).ClubHouseReservationPage,
    }),
  },
];
